<template>
<div class="content">
  <div class="header">
<!--    <el-button v-if="is_show_sync" type="primary" size="mini" @click="houseLegalToTemp()">同步欠费</el-button>-->
    <el-select size="mini" placeholder="催缴类型" clearable v-model="where2.urge_type">
      <el-option :value="1" label="自催"></el-option>
      <el-option :value="2" label="诉讼"></el-option>
      <el-option :value="3" label="第三方管理"></el-option>
      <el-option :value="4" label="第三方诉讼"></el-option>
    </el-select>
    <el-select size="mini" placeholder="账龄类型" clearable filterable multiple collapse-tags v-model="where2.age" >
      <el-option :value="1" label="当期"></el-option>
      <el-option :value="2" label="纯上一年"></el-option>
      <el-option :value="3" label="1年以上2年以内"></el-option>
      <el-option :value="4" label="2年以上"></el-option>
    </el-select>
<!--    <el-date-picker-->
<!--      style="width: 120px"-->
<!--      v-model="where2.jh_time"-->
<!--      size="mini"-->
<!--      type="month"-->
<!--      format="yyyy-MM"-->
<!--      value-format="yyyy-MM" placeholder="计划催费月份">-->
<!--    </el-date-picker>-->
    <el-date-picker
      style="width: 120px"
      v-model="where2.qf_time"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="欠费月份">
    </el-date-picker>
    <el-date-picker
      style="width: 120px"
      v-model="where2.last_month"
      size="mini"
      type="month"
      format="yyyy-MM"
      value-format="yyyy-MM" placeholder="上次缴费月份">
    </el-date-picker>
<!--    <el-select size="mini" placeholder="催费次数" clearable v-model="where2.type">-->
<!--      <el-option :value="0" label="暂未催费"></el-option>-->
<!--      <el-option :value="1" label="1次催费"></el-option>-->
<!--      <el-option :value="2" label="2次催费"></el-option>-->
<!--      <el-option :value="3" label="3次催费"></el-option>-->
<!--      <el-option :value="4" label="多次催费"></el-option>-->
<!--    </el-select>-->
    <el-input clearable placeholder="输入房产" v-model="where2.house_name" style="width: 200px" size="mini"></el-input>
<!--    <el-button size="mini" @click="exportExcel(1)">导出房产（所有房产）</el-button>-->
<!--    <el-button size="mini" @click="exportExcel(2)">导出房产（催缴房产）</el-button>-->
<!--    <el-button size="mini" @click="importLegalHouseExcel">导入催缴房产</el-button>-->
    <el-button size="mini" @click="saveBatch(true)">保存</el-button>
    <el-button size="mini" @click="lockHouse()">锁定</el-button>
    <el-button v-if="ERP.isPermission(8007001005)" size="mini" @click="unlockHouse()">解锁</el-button>
<!--    <el-button size="mini" v-if="is_show_flow" @click="toFlow(2)">项目经理审批</el-button>-->
<!--    <el-button size="mini" v-if="is_show_flow" @click="toFlow(1)">分公司管家经理审批</el-button>-->
<!--    <el-button size="mini" icon="el-icon-full-screen" @click="openFullscreen"></el-button>-->
    <el-button type="danger" size="mini" @click="delHouseIds()">批量移除</el-button>
    <el-button type="danger" size="mini" @click="deleteByAll()">全部移除</el-button>
  </div>
  <div class="header-tip">
    欠费房产数：{{pageData.total}}&nbsp;&nbsp;&nbsp;&nbsp;
    项目诉讼欠费：{{countObj.xm_ss_debt}}&nbsp;&nbsp;&nbsp;&nbsp;
    项目诉讼金额：{{countObj.xm_ss_amount}}&nbsp;&nbsp;&nbsp;&nbsp;
    第三方诉讼欠费：{{countObj.ds_ss_debt}}&nbsp;&nbsp;&nbsp;&nbsp;
    第三方诉讼金额：{{countObj.ds_ss_amount}}&nbsp;&nbsp;&nbsp;&nbsp;
  </div>
  <div class="body">
    <div>
      <div class="table-wrap">
        <VeTable
          v-loading="loading"
          ref="tableRef"
          rowKeyFieldName="id"
          :max-height="ve_table_max_height"
          :fixed-header="true"
          :virtual-scroll-option="virtualScrollOption"
          :edit-option="editOption"
         :cell-autofill-option="cellAutofillOption"
          :cellSelectionOption="cellSelectionOption"
         :rowStyleOption="rowStyleOption"
          :checkbox-option="checkboxOption"
          :cell-style-option="cellStyleOption"
          style="width: 100%;"
         :scroll-width="0"
         :border-y="true"
          :contextmenu-body-option="contextmenuBodyOption"
          :contextmenu-header-option="contextmenuHeaderOption"
          :column-width-resize-option="columnWidthResizeOption"
          :clipboard-option="clipboardOption"
          :columns="columns"
          :table-data="tableData" />
      </div>
      <div class="pagination-wrap">
        <el-select v-model="pageData.pageSize" size="mini" style="width: 80px" placeholder="每页条数" @change="pageChange(1)">
          <el-option label="10" value="10"></el-option>
          <el-option label="20" value="20"></el-option>
          <el-option label="30" value="30"></el-option>
          <el-option label="50" value="50"></el-option>
          <el-option label="100" value="100"></el-option>
          <el-option label="200" value="200"></el-option>
          <el-option label="500" value="500"></el-option>
          <el-option label="1000" value="1000"></el-option>
          <el-option label="5000" value="5000"></el-option>
          <el-option label="10000" value="10000"></el-option>
        </el-select>
        <el-pagination background layout="prev, pager, next" :total="pageData.total*1"
                       :page-size="pageData.pageSize*1" :current-page="pageData.page*1"
                       @current-change="pageChange"></el-pagination>
      </div>
    </div>
    <el-dialog title="修改催缴类型" :visible.sync="dialogVisible" :close-on-click-modal="false" @close="onClose" width="600px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ from_data['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ from_data['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ from_data['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="催缴类型">
            <el-select placeholder="催缴类型" v-model="from_data['催缴类型']">
              <el-option value="自催" label="自催"></el-option>
              <el-option value="诉讼" label="诉讼"></el-option>
              <el-option value="第三方" label="第三方"></el-option>
            </el-select>
          </el-descriptions-item>
          <el-descriptions-item label="计划催缴月份">
            <el-date-picker
              style="width: 150px"
              v-model="from_data['计划催缴月份']"
              size="mini"
              type="month"
              format="yyyy-MM"
              value-format="yyyy-MM">
            </el-date-picker>
          </el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ from_data['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ from_data['欠费类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费原因">{{ from_data['欠费原因'] }}</el-descriptions-item>
          <el-descriptions-item label="业主诉求">{{ from_data['业主诉求'] }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="onClose">关 闭</el-button>
<!--          <el-button @click="editTypeSubmit">修 改</el-button>-->
        </div>
      </template>
    </el-dialog>

    <el-dialog title="欠费明细" :visible.sync="dialogVisible_1" :close-on-click-modal="false" width="80vw">

      <div class="view-file-win">
        <el-table
          v-loading="loading" :data="house_bill_order" height="60vh"
          border
          style="width: 100%">
          <el-table-column
            prop="h_name_date"
            label="房产信息" width="360" fixed></el-table-column>
          <el-table-column
            prop="charge_name"
            label="费项"
            width="150">
          </el-table-column>
          <el-table-column
            prop="BillDate"
            label="收费周期"
            width="150">
          </el-table-column>
          <el-table-column
            prop="charge"
            label="金额"
            width="100">
          </el-table-column>
          <el-table-column
            prop="h_name"
            label="业主">
          </el-table-column>
        </el-table>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="dialogVisible_1=false">关 闭</el-button>
        </div>
      </template>
    </el-dialog>

    <el-dialog title="最后一次缴费明细" :visible.sync="dialogVisible_2" :close-on-click-modal="false" width="600px">

      <div class="view-file-win">
        <el-descriptions class="margin-top" :column="1" size="mini" border>
          <el-descriptions-item label="房产信息">{{ house_bill_order_2['房产信息'] }}</el-descriptions-item>
          <el-descriptions-item label="区域">{{ house_bill_order_2['区域'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费金额">{{ house_bill_order_2['欠费金额'] }}</el-descriptions-item>
          <el-descriptions-item label="账龄类型">{{ house_bill_order_2['账龄类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费类型">{{ house_bill_order_2['欠费类型'] }}</el-descriptions-item>
          <el-descriptions-item label="欠费原因">{{ house_bill_order_2['欠费原因'] }}</el-descriptions-item>
          <el-descriptions-item label="业主诉求">{{ house_bill_order_2['业主诉求'] }}</el-descriptions-item>
        </el-descriptions>
      </div>
      <template slot="footer">
        <div>
          <el-button @click="dialogVisible_2=false">关 闭</el-button>
        </div>
      </template>
    </el-dialog>

  </div>
  <ViewFile ref="ViewFile" />
  <ViewFlow ref="viewFlowRef" />
</div>
</template>

<script>
import Http from "../../common/Http";
import moment from "moment/moment";
import ViewFile from "../../../Common/ViewFile";
import Track from "../../../../../assets/js/trackHttp";
import {CommonHelp} from "../../common/CommonHelp";
import ViewFlow from "../../../Common/ViewFlow";
import ButlerHttp from "../../common/ButlerHttp";

const editCell = ['plan_urge_month','lawsuit_amount','urge_type','third_party_company','debt_type','debt_reason','owner_demand','solution'];
export default {
  name: "LegalHouseYearPlanTempExcel",
  components: {ViewFlow, ViewFile},
  inject:['where','reginWhere'],
  props: {
    is_show_flow:{
      type:Boolean,
      default:false
    },
    is_show_sync:{
      type:Boolean,
      default:false
    },
    project_id:{
      type:Number,
      default:0
    },
    year_month:{
      type:String,
      default:moment().format("YYYY-MM")
    }
  },
  data(){
    const self = this;
    return{
      where2:{
        urge_type:"",
        age:'',
        type:"",
        qf_time:moment().format("YYYY-MM"),
        jh_time:"",
        last_month:"",
        house_name:"",
        order_by:"",
      },
      loading:false,
      pageData:{
        list: [],
        total: 0,
        pageSize: 15,
        page: 1,
      },
      countObj:{
        xm_ss_amount:0,
        ds_ss_amount:0,
        xm_ss_debt:0,
        ds_ss_debt:0,
      },
      from_data:{},
      dialogVisible:false,
      house_bill_order:[],
      dialogVisible_1:false,
      dialogVisible_2:false,
      house_bill_order_2:{},
      multipleSelection:[],
      ve_table_max_height:'50vh',
      columns:[
        {
          field: "",
          key: "a",
          // type=checkbox
          type: "checkbox",
          title: "",
          width: 50,
          align: "center",
        },
        { field: "house_name", key: "house_name", title: "房产信息", align: "center" ,width:320,fixed: "left" ,ellipsis: {showTitle: true}},
        { field: "area_name", key: "area_name", title: "区域", align: "center" ,width:90 },
        { field: "owner_name", key: "owner_name", title: "业主姓名", align: "center" ,width:220 },
        { field: "owner_phone", key: "owner_phone", title: "业主电话", align: "center" ,width:220 },
        { field: "is_lock", key: "is_lock", title: "锁定", align: "center" ,width:100,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <el-link type={row["is_lock"]? "success" : "warning"}>
                {row["is_lock"]? "已锁定" : "未锁定"}
              </el-link>
            );
          },
        },
        { field: "bank_account", key: "bank_account", title: "银行划扣", align: "center" ,width:90 },
        { field: "debt_start_month", key: "debt_start_month", title: "欠费起始月份", align: "center" ,width:120 },
        { field: "debt_month", key: "debt_month", title: "欠费月数", align: "center" ,width:100 },
        { field: "debt_amount", key: "debt_amount", title: "欠费金额", align: "center" ,width:100 },
        { field: "plan_urge_month", key: "plan_urge_month", title: "计划催缴月份", align: "center",width:150,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            row["plan_urge_month"] = this.year_month;
            return row["plan_urge_month"];
          },
        },
        { field: "urge_type", key: "urge_type", title: "催缴类型", align: "center",width:120,edit: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <el-select
                size="mini"
                style="width: 100%;"
                filterable
                clearable
                value={row["urge_type"]}
                on-change={(val) => {
                  row["urge_type"] = val;
                  if(val == "诉讼" || val == "第三方诉讼"){
                    row["lawsuit_amount"] = row["debt_amount"];
                  }else {
                    row["lawsuit_amount"] = 0;
                  }
                  this.cellDataChange(row, column, val);
                }}
                placeholder="请选择催缴类型"
              >
                <el-option value="" label="--"></el-option>
                <el-option value="诉讼" label="诉讼"></el-option>
                <el-option value="第三方诉讼" label="第三方诉讼"></el-option>
              </el-select>
            );
          },
        },
        { field: "lawsuit_amount", key: "lawsuit_amount", title: "诉讼金额", align: "center" ,width:200 ,edit: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return row["lawsuit_amount"];
          },
        },
        { field: "third_party_company", key: "third_party_company", title: "第三方合作单位", align: "center",width:150,edit: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <el-select
                size="mini"
                style="width: 100%;"
                filterable
                clearable
                value={row["third_party_company"]}
                on-input={(val) => {
                  row["third_party_company"] = val;
                }}
                on-change={(val) => {
                  this.cellDataChange(row, column, val);
                }}
                placeholder="请选择"
              >
                {
                  this.company_list.map((item) => {
                    return <el-option value={item.name} label={item.name}></el-option>
                  })
                }
              </el-select>
            );
          },
        },
        { field: "debt_type", key: "debt_type", title: "欠费类型", align: "center",width:150,edit: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <el-select
                size="mini"
                style="width: 100%;"
                filterable
                clearable
                value={row["debt_type"]}
                on-input={(val) => {
                  row["debt_type"] = val;
                }}
                on-change={(val) => {
                  row["debt_reason"] = "";
                  this.cellDataChange(row, column, val);
                }}
                placeholder="请选择"
              >
                {
                  this.arrears_arr.map((item) => {
                    return <el-option value={item.name} label={item.name}></el-option>
                  })
                }
              </el-select>
            );
          },
        },
        { field: "debt_reason", key: "debt_reason", title: "欠费原因", align: "center",width:150,edit: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            if(row["debt_type"] == "其它(手写)"||row["debt_type"] == "正常缴费"){
              return row["debt_reason"];
            }else {
              return (
                <el-select
                  size="mini"
                  style="width: 100%;"
                  filterable
                  clearable
                  value={row["debt_reason"]}
                  on-input={(val) => {
                    row["debt_reason"] = val;
                  }}
                  on-change={(val) => {
                    this.cellDataChange(row, column, val);
                  }}
                  placeholder="请选择"
                >
                  {
                    ((this.arrears_arr.filter(item => item.name == row["debt_type"])[0] || {}).children||[]).map((item) => {
                      return <el-option value={item.name} label={item.name}></el-option>
                    })
                  }
                </el-select>
              );
            }
          },
        },
        { field: "owner_demand", key: "owner_demand", title: "业主诉求", align: "center",width:150,edit: true,ellipsis: {showTitle: true}},
        { field: "solution", key: "solution", title: "解决措施", align: "center",width:150,edit: true,ellipsis: {showTitle: true}},
        { field: "debt_age_type", key: "debt_age_type", title: "账龄类型", align: "center" ,width:90},
        { field: "payment_type", key: "payment_type", title: "缴费类型", align: "center" ,width:90 },
        { field: "last_payment_time", key: "last_payment_time", title: "上次缴费时间", align: "center" ,width:170 },
        { field: "first_urge_time", key: "first_urge_time", title: "第一次催费时间", align: "center" ,width:170 },
        { field: "second_urge_time", key: "second_urge_time", title: "第二次催费时间", align: "center" ,width:170 },
        { field: "third_urge_time", key: "third_urge_time", title: "第三次催费时间", align: "center" ,width:170 },
        { field: "house_id", key: "house_id", title: "房产ID", align: "center" ,width:100 },
      ],
      tableData: [],
      submitData: [],
      virtualScrollOption:{
        enabled: true,
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (editCell.includes(column.field)) {
            return "table-header-cell-class";
          }
        },
      },
      editOption:{
        // cellValueChange: ({ row, column }) => {
        //   console.log("cellValueChange row::", row);
        //   console.log("cellValueChange column::", column);
        // },
        afterCellValueChange: ({ row, column, changeValue  }) => {
          this.cellDataChange(row, column, changeValue);
        }
      },
      cellAutofillOption: {
        directionX: false,
        directionY: true,
        beforeAutofill({sourceSelectionRangeIndexes, targetSelectionRangeIndexes,sourceSelectionData, targetSelectionData}){
          let sourceSelection=sourceSelectionData[0]
          let keys = Object.keys(sourceSelection);
          if(keys.length>0){
            if(editCell.includes(keys[1])){
              targetSelectionData.forEach(val => {
                let filed=Object.keys(val)[1];
                self.cellDataChangeValue(val.id,filed,sourceSelection[filed]);
              });
              return true;
            }
          }

          // console.log("keys::", keys);
          return false;
        }
      },
      rowStyleOption: {
        clickHighlight: false,
        hoverHighlight: false,
      },
      cellSelectionOption: {
        // disble cell selection
        enable: true,

      },
      checkboxOption: {
        // 行选择改变事件
        selectedRowChange: ({ row, isSelected, selectedRowKeys }) => {
          console.log(row, isSelected, selectedRowKeys);
          this.multipleSelection = selectedRowKeys;
        },
        // 全选改变事件
        selectedAllChange: ({ isSelected, selectedRowKeys }) => {
          console.log(isSelected, selectedRowKeys);
          this.multipleSelection = selectedRowKeys;
        },
      },
      // 表头右击菜单选项
      contextmenuHeaderOption: {
        /*
        before contextmenu show.
        In this function,You can change the `contextmenu` options
        */
        beforeShow: ({
                       isWholeColSelection,
                       selectionRangeKeys,
                       selectionRangeIndexes,
                     }) => {
          console.log("---contextmenu header beforeShow--");
          console.log("isWholeColSelection::", isWholeColSelection);
          console.log("selectionRangeKeys::", selectionRangeKeys);
          console.log("selectionRangeIndexes::", selectionRangeIndexes);
        },
        // after menu click
        afterMenuClick: ({ type, selectionRangeKeys, selectionRangeIndexes }) => {
          let startColKey = selectionRangeKeys.startColKey;
          switch (type) {
            case "EMPTY_COLUMN":
              console.log("清空列");
              break;
            case "ORDER_ASC":
              console.log("升序",startColKey);
              self.where2.order_by=startColKey+" asc";
              break;
            case "ORDER_DESC":
              console.log("降序",startColKey);
              self.where2.order_by=startColKey+" desc";
              break;
            case "LEFT_FIXED_COLUMN_TO":
              console.log("左列冻结至该列");
              break;
            case "CANCEL_LEFT_FIXED_COLUMN_TO":
              console.log("取消左列冻结至该列");
              break;
            case "RIGHT_FIXED_COLUMN_TO":
              console.log("右列冻结至该列");
              break;
            case "CANCEL_RIGHT_FIXED_COLUMN_TO":
              console.log("取消右列冻结至该列");
              break;
          }
        },

        // contextmenus
        contextmenus: [
          // {
          //   label: "剪切",
          //   type: "CUT",
          // },
          // {
          //   label: "复制",
          //   type: "COPY",
          // },
          // {
          //   label: "分割线",
          //   type: "SEPARATOR",
          // },
          {
            label: "排序",
            type: "ORDER",
            children: [
              {
                label: "升序",
                type: "ORDER_ASC",
              },
              {
                label: "降序",
                type: "ORDER_DESC",
              },
            ],
          },
          // {
          //   label: "分割线",
          //   type: "SEPARATOR",
          // },
          // {
          //   label: "清空列",
          //   type: "EMPTY_COLUMN",
          // },
          {
            label: "分割线",
            type: "SEPARATOR",
          },
          {
            label: "左列冻结至该列",
            type: "LEFT_FIXED_COLUMN_TO",
          },
          {
            label: "取消左列冻结至该列",
            type: "CANCEL_LEFT_FIXED_COLUMN_TO",
          },
          {
            label: "右列冻结至该列",
            type: "RIGHT_FIXED_COLUMN_TO",
          },
          {
            label: "取消右列冻结至该列",
            type: "CANCEL_RIGHT_FIXED_COLUMN_TO",
          },
        ],
      },

      // 内容右击菜单选项
      contextmenuBodyOption: {
        /*
        before contextmenu show.
        In this function,You can change the `contextmenu` options
        */
        beforeShow: ({
                       isWholeRowSelection,
                       selectionRangeKeys,
                       selectionRangeIndexes,
                     }) => {
          console.log("---contextmenu body beforeShow--");
          console.log("isWholeRowSelection::", isWholeRowSelection);
          console.log("selectionRangeKeys::", selectionRangeKeys);
          console.log("selectionRangeIndexes::", selectionRangeIndexes);
        },
        // after menu click
        afterMenuClick: ({ type, selectionRangeKeys, selectionRangeIndexes }) => {
          console.log("---contextmenu body afterMenuClick--");
          console.log("type::", type);
          console.log("selectionRangeKeys::", selectionRangeKeys);
          console.log("selectionRangeIndexes::", selectionRangeIndexes);
        },

        // contextmenus
        contextmenus: [
          // {
          //   label: "剪切",
          //   type: "CUT",
          // },
          {
            label: "复制",
            type: "COPY",
          },
          {
            label: "分割线",
            type: "SEPARATOR",
          },
          // {
          //   label: "在上方插入行",
          //   type: "INSERT_ROW_ABOVE",
          // },
          // {
          //   label: "在下方插入行",
          //   type: "INSERT_ROW_BELOW",
          // },
          {
            label: "分割线",
            type: "SEPARATOR",
          },
          // {
          //   label: "删除行",
          //   type: "REMOVE_ROW",
          // },
          // {
          //   label: "清空行",
          //   type: "EMPTY_ROW",
          // },
          // {
          //   label: "清空单元格",
          //   type: "EMPTY_CELL",
          // },
        ],
      },
      columnWidthResizeOption: {
        // default false
        enable: true,
        // column resize min width
        minWidth: 30,
      },
      clipboardOption: {
        copy: true,
        paste: true,
        cut: false,
        delete: true,
        beforePaste: ({ data, selectionRangeIndexes, selectionRangeKeys }) => {
          if(!editCell.includes(selectionRangeKeys.startColKey)){
            return false;
          }
          let tableData=JSON.parse(JSON.stringify(self.tableData));
          let newData=tableData.splice(selectionRangeIndexes.startRowIndex, selectionRangeIndexes.endRowIndex+1);
          newData.forEach((item,index) => {
            self.cellDataChangeValue(item.id, selectionRangeKeys.startColKey, ((data[index]||{})[selectionRangeKeys.startColKey]||''));
          })
          return true;
        },
      },
      company_list:[],
      arrears_arr:[
        {
          id: 4,
          name: "房屋及基础措施类",
          children: [
            { id: 5, name: "房屋质量问题" },
            { id: 6, name: "物业管理的公共部分导致的房屋质量问题" },
            { id: 7, name: "公共设施原因" },
          ],
        },
        {
          id: 5,
          name: "物业服务类",
          children: [
            { id: 8, name: "安保管理安全问题" },
            { id: 9, name: "物业人员服务态度问题" },
            { id: 10, name: "物业管理服务不到位问题" },
            { id: 11, name: "工程维修问题" },
          ],
        },
        {
          id: 6,
          name: "业主自身原因类",
          children: [
            { id: 12, name: "炒房" },
            { id: 13, name: "失联" },
            { id: 14, name: "异地居住" },
            { id: 15, name: "拖延缴费" },
          ],
        },
        {
          id: 16,
          name: "正常缴费",
        },
        {
          id: 7,
          name: "其它(手写)",
        },
      ],
    }
  },
  mounted() {
    const that=this;
    this.getAllOfIdAndName()
    this.pageChange(1);
    const elem = that.$refs.tableRef.$el;
    elem.addEventListener('fullscreenchange', function (event) {
      console.log('fullscreenchange',event);
      if (elem.requestFullscreen || elem.mozRequestFullScreen || elem.webkitRequestFullscreen || elem.msRequestFullscreen) {
        that.ve_table_max_height = '100vh';
      } else {
        that.ve_table_max_height = '50vh';
      }
    });
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.age":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.urge_type":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.qf_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.jh_time":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.last_month":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.house_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
    "where2.order_by":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        that.pageChange(1);
      },500,that);
    },
  },
  computed:{
    ids(){
      return this.multipleSelection
    }
  },
  methods:{
    getList(){
      const that = this;
      that.loading = true;
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.project_id,
        area_id:that.reginWhere.area_id,
        year_month:that.year_month,
      }
      where.age=where.age.join(',')

      ButlerHttp.post("ProjectCollectionProceedingPlanHouse/index",{
        ...where,
        page: that.pageData.page,
        pageSize: that.pageData.pageSize
      }, res => {
        if (res.code) {
          that.countObj = res.data.countObj
          that.pageData = res.data
          that.tableData = res.data.list
        }
        that.loading = false;
      })
    },
    pageChange(i) {
      const that=this;
      that.pageData.page = i;
      CommonHelp.debounce(()=>{
        if(that.submitData.length>0){
          that.saveBatch(false)
        }
        that.getList()
      },500,that);

    },
    onClose(){
      this.dialogVisible=false;
      this.from_data={}
    },
    getHouseBill(item){
      const that=this;
      ERP.showLoading()
      ButlerHttp.post("Legal/getHouseBill", {
        projectId: item.project_id,
        houseId: item.house_id
      }, res => {
        ERP.hideLoading();
        if (res.code) {
          that.dialogVisible_1 = true;
          that.house_bill_order = res.data;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    getLastHouseBill(item){
      const that=this;
      ButlerHttp.post("Legal/getLastHouseBill", {
        projectId: item.project_id,
        houseId: item.house_id,
        last_time: item.last_payment_time
      }, res => {
        if (res.code) {
          that.dialogVisible_2 = true;
          that.house_bill_order_2 = res.data;
        } else {
          that.$message.error(res.msg);
        }
      });
    },
    delHouse(item){
      const that=this;
      that.loading = true;
      ButlerHttp.post("ProjectCollectionProceedingPlanHouse/delete",{
        id:item.id,
        project_id:that.project_id,
        year_month:that.year_month
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("删除成功")
          that.pageChange(1);
          that.$emit("onAdd")
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    delHouseIds(){
      const that=this;
      if(!that.project_id){
        that.$message.error('请选择项目！');
        return false
      }
      if(!that.ids.length){
        that.$message.error('请勾选房产！');
        return false
      }
      that.loading = true;
      ButlerHttp.post("ProjectCollectionProceedingPlanHouse/deleteBatch",{
        ids:that.ids.join(','),
        project_id:that.project_id,
        year_month:that.year_month
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("删除成功")
          that.pageChange(1);
          that.$emit("onAdd")
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    deleteByAll(){
      const that=this;
      if(!that.project_id){
        that.$message.error("请选择项目")
        return false
      }
      let where = {
        ...that.where2,
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.project_id,
        area_id:that.reginWhere.area_id,
        year_month:that.year_month,
      }
      that.loading = true;
      ButlerHttp.post("ProjectCollectionProceedingPlanHouse/deleteByAll",where, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("删除成功")
          that.pageChange(1);
          that.$emit("onAdd")
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    openFlow(item){
      const that = this;
      if(!item.task_id){
        that.$message.error('没有审批流程')
        return;
      }
      that.$refs.viewFlowRef.show({task_id:item.task_id})
    },
    openFullscreen() {
      const that = this;
      const elem = that.$refs.tableRef.$el;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.mozRequestFullScreen) { /* Firefox */
        elem.mozRequestFullScreen();
      } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) { /* IE/Edge */
        elem.msRequestFullscreen();
      }
    },
    getAllOfIdAndName(){
      const that=this;
      ButlerHttp.get("ProjectCollectionThridCompany/getAllOfIdAndName",{}, res => {
        if (res.code) {
          that.company_list=res.data
        }
      });
    },
    saveBatch(is_load=true){
      const that=this;
      if(!that.project_id) {
        that.$message.error('请选择项目！');
        return false
      }
      that.loading = true;
      ButlerHttp.post("ProjectCollectionProceedingPlanHouse/saveBatch",{
        list:JSON.stringify(that.submitData),
        project_id:that.project_id,
        year_month:that.year_month
      }, res => {
        that.loading = false;
        if (res.code) {
          that.submitData=[];
          that.$message.success("保存成功")
          is_load&&that.pageChange(1);
          is_load&&that.$emit("onAdd")
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    lockHouse(){
      const that=this;
      if(!that.project_id) {
        that.$message.error('请选择项目！');
        return false
      }
      ButlerHttp.post("ProjectCollectionProceedingPlanHouse/lockHouse",{
        year_month:that.year_month,
        project_id:that.project_id
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("保存成功")
          that.pageChange(1);
          that.$emit("onAdd")
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    unlockHouse(){
      const that=this;
      if(!that.project_id) {
        that.$message.error('请选择项目！');
        return false
      }
      ButlerHttp.post("ProjectCollectionProceedingPlanHouse/unlockHouse",{
        year_month:that.year_month,
        project_id:that.project_id
      }, res => {
        that.loading = false;
        if (res.code) {
          that.$message.success("保存成功")
          that.pageChange(1);
          that.$emit("onAdd")
        }else {
          that.$message.error(res.msg);
        }
      })
    },
    cellDataChange(row, column, cellValue) {
      const that = this;
      const { submitData } = this;

      row[column.field] = cellValue;
      let currentCellIndex = submitData.findIndex((x) => x.id === row["id"]);
      if (currentCellIndex === -1) {
        that.submitData.push(row);
      }else {
        that.submitData[currentCellIndex] = row;
      }
    },
    cellDataChangeValue(id, name, value) {
      const that = this;
      const { submitData,tableData } = this;
      let row = tableData.find((x) => x.id == id);
      if (!row) {
        that.$message.error("数据异常");
        return;
      }
      row[name] = value;
      let currentCellIndex = submitData.findIndex((x) => x.id == id);
      if (currentCellIndex === -1) {
        that.submitData.push(row);
      }else {
        that.submitData[currentCellIndex] = row;
      }
    },
    cellDataChangeRow(id) {
      const that = this;
      const { submitData,tableData } = this;
      let row = tableData.find((x) => x.id == id);
      let currentCellIndex = submitData.findIndex((x) => x.id == id);
      if (currentCellIndex!== -1) {
        that.submitData.push(row);
      }else {
        that.submitData[currentCellIndex] = row;
      }
    },
    roundValue(num, n=2){
      return Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
    }
  }
}

</script>

<style lang="scss" scoped>
@import "../../common";
.content{
  min-height: calc(100vh - 350px);

  .header-tip{
    margin: 5px 0;
    padding: 5px 10px;
    background-color: #f56c6c;
    color: #FFFFFF;
    border-radius: 4px;
    display: inline-block;
  }
  .body{
    .table-wrap{
      .table-wrap-table{
        width: 100%;

      }

    }
    .pagination-wrap{
      display: flex;
      justify-content: flex-end;
      margin-top: 10px;
    }
  }

}

/deep/ .el-table th.el-table__cell.is-leaf{
  padding: 0;
  margin: 0;
  .label-column-edit{
    background-color: #f56c6c;
    color: #FFFFFF;
    cursor: pointer;
    padding: 8px 0;
    text-align: center;
  }
}

/deep/ .table-header-cell-class {
  background: orange !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/plan/LegalHouseYearPlanTempExcel.vue